import { Component } from '@angular/core';
import { GamesGroupService, GroupType, LeaderboardType, TriviaGroupSummary } from '@fgb/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgb-trivia-leaderboard-page',
  templateUrl: './trivia-leaderboard-page.component.html',
  styleUrls: ['./trivia-leaderboard-page.component.scss'],
})
export class TriviaLeaderboardPageComponent {
  LeaderboardType: LeaderboardType = LeaderboardType.TriviaPoints;
  gamesGroup$: Observable<TriviaGroupSummary[]>;
  groupType = GroupType.Trivia;

  constructor(private gamesGroupService: GamesGroupService) {}
  ngOnInit(): void {
    this.gamesGroup$ = this.gamesGroupService.fetchTriviaGroups();
  }
}
